import { useEffect } from "react";
import { App } from "antd";
import { setIOSDialogHandler, setMessageApi, setModalApi } from "@ifa/utils";
import { useIOSConfirm } from "../hooks/useIOSConfirm";

const escapeHtml = (text: string) => text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");

export function MessageBridge() {
  const { message, modal } = App.useApp();
  const { confirm } = useIOSConfirm();
  useEffect(() => {
    setMessageApi(message);
    setModalApi(modal);
    setIOSDialogHandler((options) => {
      const {
        title = "提示",
        content,
        okText = "確定",
        showCancel = false,
        onOk,
      } = options;

      // 如果 showCancel 为 false，使用简单样式
      if (!showCancel) {
        const safeContent = escapeHtml(content).replace(/\n/g, "<br/>");
        confirm({
          title,
          content: safeContent,
          okText,
          showCancel: false,
          onOk,
          dangerouslySetInnerHTML: true,
        });
      } else {
        // 有取消按钮时使用标准样式
        confirm({
          title,
          content,
          okText,
          showCancel,
          onOk,
        });
      }
    });
    return () => {
      setMessageApi(null);
      setModalApi(null);
      setIOSDialogHandler(null);
    };
  }, [message, modal, confirm]);
  return null;
}
